import { stats } from '@/mocks/homepage';

export default function StatsSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-primary-500">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-background-50/75 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}